const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-sm">
            © {currentYear} Luis Felipe Cubero Vargas. All rights reserved.
          </p>
          <p className="text-xs text-gray-400 mt-2">
            Built with React, Vite, and Tailwind CSS • Hosted on Cloudflare Pages
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
